// extracted by mini-css-extract-plugin
export default {"IconItem":"IconItem_IconItem__RS+er","icon":"IconItem_icon__tCyPW","round":"IconItem_round__2sI35","circle":"IconItem_circle__Qumfp","text":"IconItem_text__Z23pr"};